import React from 'react'

const TrackTable = () => {
    return (
        <>
            <section className="about-area pb-60 pt-60">
                <div className="container">
                <h2 className='pb-4'  data-aos="fade-up" data-aos-delay="100">Listing of NASCAR Cup Series, Xfinity Series, Camping <br/> World Truck Series & ARCA Menards Series Owners</h2>
                    <table className="table  table-dark table-striped table-bordered border-light">
                        {/* <thead>
                            <tr style={{width:'100%'}}>
                                <th scope="col" style={{width:'25%'}}>TRACK</th>
                                <th scope="col" style={{width:'25%'}}>LOCATION</th>
                                <th scope="col" style={{width:'25%'}}>COUNTRY</th>
                                <th scope="col" style={{width:'25%'}}>FIRST RACE</th>
                               
                            </tr>
                        </thead> */}
                        <tbody>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                            <tr>
                                <th scope="row">Paul Aars</th>
                                <td>Van Acker</td>
                                <td>Ed Ackerman</td>
                                <td>Betty Adams</td>
                              
                            </tr>
                         
                         
                        </tbody>
                    </table>
                </div>
            </section>
        </>
    )
}

export default TrackTable